import { Pipe, PipeTransform } from '@angular/core';
import { sortByProperty } from '../../core/utils/collection.utils';
import { SortInterface } from '../components/sort-control/sort.interface';

@Pipe({
  name: 'sort'
})
export class SortPipe implements PipeTransform {
  transform(value: any[], sort: SortInterface): any[] {
    return (sort) ? sortByProperty(sort.attribute, sort.type, sort.reverse, value) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/shared/pipes/sort.pipe.ts